import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { 
  FaMapMarkerAlt, FaClock, FaCheck, FaWhatsapp, 
  FaStar, FaEnvelope, FaPhone, FaUsers, FaCalendar,
  FaShieldAlt, FaFemale, FaLeaf
} from 'react-icons/fa';

const TourDetail = () => {
  const { id } = useParams();
  const [tour, setTour] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeImage, setActiveImage] = useState(0);

  // WhatsApp number
  const whatsappNumber = "251912093264";

  // Tour database - expand with more tours
  const toursData = {
    'addis-ababa-city-tour': {
      id: 'addis-ababa-city-tour',
      title: "Addis Ababa City Tour – Full Day",
      location: "Addis Ababa",
      duration: "Full Day (8-10 hours)",
      price: "On Request",
      rating: 4.9,
      reviews: 128,
      description: "Experience Ethiopia's vibrant capital through women's eyes. Visit the National Museum (home of Lucy), Holy Trinity Cathedral, Merkato - Africa's largest market, and enjoy an authentic Ethiopian coffee ceremony.",
      fullDescription: "Discover the heart of Ethiopia with our women-led Addis Ababa city tour. This comprehensive full-day experience takes you through the city's most significant historical, cultural, and commercial sites, all while supporting local women entrepreneurs.\n\nYour journey begins at the National Museum of Ethiopia, where you'll meet Lucy, our 3.2 million-year-old ancestor. Continue to Holy Trinity Cathedral, one of the most important religious sites in Ethiopia, featuring stunning architecture and the tombs of Emperor Haile Selassie and other royalty.\n\nAfter a traditional Ethiopian lunch at a women-owned restaurant, explore Merkato, the largest open-air market in Africa. Our female guides will introduce you to women vendors and artisans, sharing stories of their businesses and crafts. The day concludes with a traditional coffee ceremony, where you'll learn about the origins of coffee and its cultural significance.",
      includes: [
        "Professional female guide",
        "Private vehicle with driver",
        "Traditional coffee ceremony",
        "Entrance fees to all sites",
        "Bottled water",
        "Lunch at women-owned restaurant"
      ],
      excludes: [
        "Personal expenses",
        "Tips and gratuities",
        "Travel insurance"
      ],
      itinerary: [
        { time: "9:00 AM", title: "National Museum of Ethiopia", description: "Meet Lucy and explore Ethiopian history" },
        { time: "11:00 AM", title: "Holy Trinity Cathedral", description: "Visit one of Addis' most important religious sites" },
        { time: "1:00 PM", title: "Traditional Lunch", description: "Enjoy authentic Ethiopian cuisine at women-owned restaurant" },
        { time: "2:30 PM", title: "Merkato Market", description: "Explore Africa's largest open-air market" },
        { time: "4:30 PM", title: "Coffee Ceremony", description: "Experience Ethiopia's ancient coffee tradition" }
      ],
      images: ['/images/addis-tour.jpg', '/images/addis-2.jpg', '/images/addis-3.jpg'],
      highlights: [
        "Women-led guiding experience",
        "Support local women vendors",
        "Authentic coffee ceremony",
        "Visit Africa's largest market"
      ],
      meetingPoint: "Your hotel in Addis Ababa",
      groupSize: "1-8 people",
      bestTime: "All year round"
    },
    'debre-libanos': {
      id: 'debre-libanos',
      title: "Debre Libanos & Portuguese Bridge – Day Tour",
      location: "Debre Libanos, Oromia",
      duration: "1 Day",
      price: "On Request",
      rating: 4.8,
      reviews: 94,
      description: "Visit the historic Debre Libanos Monastery, explore the Portuguese Bridge, and enjoy breathtaking views of the Blue Nile Gorge.",
      fullDescription: "Escape the city and immerse yourself in Ethiopia's natural beauty and religious history. This day tour takes you to Debre Libanos, one of Ethiopia's most important monasteries, founded by Saint Tekle Haymanot in the 13th century.\n\nPerched on a stunning cliffside, the monastery offers spectacular views of the surrounding countryside. You'll also visit the famous Portuguese Bridge, a 16th-century stone bridge spanning the Jemma River gorge, and enjoy breathtaking vistas of the Blue Nile Gorge – often called the 'Grand Canyon of Ethiopia'.\n\nYour women guide will share stories of the monastery's history, local legends, and the significance of this holy site in Ethiopian Orthodox Christianity. Lunch is included at a local restaurant featuring traditional Oromo cuisine.",
      includes: [
        "Professional female guide",
        "Private transport",
        "Lunch",
        "Entrance fees",
        "Bottled water"
      ],
      excludes: [
        "Personal expenses",
        "Tips"
      ],
      itinerary: [
        { time: "8:00 AM", title: "Departure from Addis Ababa", description: "Scenic drive through Ethiopian countryside" },
        { time: "10:00 AM", title: "Debre Libanos Monastery", description: "Visit the historic monastery and cliffside setting" },
        { time: "12:30 PM", title: "Lunch", description: "Traditional Oromo cuisine at local restaurant" },
        { time: "2:00 PM", title: "Portuguese Bridge", description: "Explore the 16th-century bridge" },
        { time: "3:00 PM", title: "Blue Nile Gorge Viewpoint", description: "Spectacular views and photo opportunities" },
        { time: "5:00 PM", title: "Return to Addis Ababa", description: "Arrive back at your hotel" }
      ],
      images: ['/images/debre-libanos.jpg'],
      highlights: [
        "Ancient cliffside monastery",
        "Portuguese Bridge history",
        "Blue Nile Gorge views",
        "Traditional Oromo lunch"
      ],
      meetingPoint: "Your hotel in Addis Ababa",
      groupSize: "1-8 people",
      bestTime: "October to March (dry season)"
    },
    'lalibela': {
      id: 'lalibela',
      title: "Lalibela Historical Tour – 3 Days",
      location: "Lalibela, Northern Ethiopia",
      duration: "3 Days, 2 Nights",
      price: "On Request",
      rating: 5.0,
      reviews: 156,
      description: "Explore the legendary rock-hewn churches of Lalibela, a UNESCO World Heritage Site and spiritual heart of Ethiopian Christianity.",
      fullDescription: "Journey to the 'Eighth Wonder of the World' – 11 monolithic rock-hewn churches carved from living stone in the 12th century. Our female guides from Lalibela share generations of history and spiritual significance as you explore this sacred site.\n\nThis 3-day tour includes visits to all churches, divided into the Northern, Eastern, and Western groups. You'll witness incredible engineering and artistry, learn about the legends of King Lalibela, and experience the living faith of Ethiopian Orthodox Christianity. The tour includes domestic flights from Addis Ababa, comfortable accommodations, and all meals.",
      includes: [
        "Female guide from Lalibela",
        "Domestic flights (Addis-Lalibela-Addis)",
        "2 nights hotel accommodation",
        "All meals",
        "Entrance fees to all churches",
        "Private transport in Lalibela"
      ],
      excludes: [
        "International flights",
        "Travel insurance",
        "Personal expenses",
        "Tips"
      ],
      itinerary: [
        { day: 1, title: "Arrival in Lalibela", description: "Fly from Addis Ababa, transfer to hotel, afternoon orientation walk" },
        { day: 2, title: "Northern & Eastern Churches", description: "Visit Bet Medhane Alem, Bet Maryam, Bet Golgotha, and Bet Amanuel" },
        { day: 3, title: "Western Churches & Departure", description: "Visit Bet Giyorgis (St. George's Church), afternoon flight to Addis" }
      ],
      images: ['/images/lalibela.jpg'],
      highlights: [
        "All 11 rock-hewn churches",
        "UNESCO World Heritage Site",
        "Local female guide",
        "Spiritual experience"
      ],
      meetingPoint: "Addis Ababa Bole International Airport",
      groupSize: "2-10 people",
      bestTime: "October to March"
    },
    'omo-valley': {
      id: 'omo-valley',
      title: "Omo Valley Cultural Tour – 5 Days",
      location: "Omo Valley",
      duration: "5 Days, 4 Nights",
      price: "On Request",
      rating: 4.9,
      reviews: 87,
      description: "Meet indigenous tribes with ancient traditions still alive today. Visit the Mursi, Hamer, and Karo people.",
      fullDescription: "Experience one of the most culturally diverse regions in Africa. The Omo Valley is home to numerous indigenous tribes who maintain ancient traditions in dress, body art, and ceremonies. This 5-day tour takes you to meet the Mursi (famous for lip plates), the Hamer (known for their bull-jumping ceremony), and the Karo (renowned for body painting).\n\nYour guide, a local woman from the region, provides respectful access to these communities, explaining their customs and facilitating meaningful cultural exchange. You'll visit local villages, witness traditional dances, and learn about the challenges these communities face in the modern world. Accommodations are in basic but comfortable lodges.",
      includes: [
        "Local female guide",
        "4WD transport",
        "All accommodation",
        "All meals",
        "Village entrance fees",
        "Cultural performances"
      ],
      excludes: [
        "Travel insurance",
        "Personal expenses",
        "Tips",
        "Alcoholic beverages"
      ],
      itinerary: [
        { day: 1, title: "Addis to Arba Minch", description: "Drive south, visit Dorze village en route" },
        { day: 2, title: "Arba Minch to Turmi", description: "Visit Key Afer market, encounter Hamer people" },
        { day: 3, title: "Turmi Area", description: "Visit Mursi villages, see lip plate tradition" },
        { day: 4, title: "Turmi to Jinka", description: "Visit Karo villages along Omo River" },
        { day: 5, title: "Jinka to Addis", description: "Visit Ari people, fly back from Jinka" }
      ],
      images: ['/images/omo-valley.jpg'],
      highlights: [
        "Mursi lip plate women",
        "Hamer bull-jumping ceremony",
        "Karo body painting",
        "Authentic cultural exchange"
      ],
      meetingPoint: "Your hotel in Addis Ababa",
      groupSize: "4-8 people",
      bestTime: "June to September (green season)"
    },
    'danakil': {
      id: 'danakil',
      title: "Danakil Depression Expedition – 4 Days",
      location: "Danakil Depression, Afar Region",
      duration: "4 Days, 3 Nights",
      price: "On Request",
      rating: 4.8,
      reviews: 76,
      description: "Witness Earth's most extreme and colorful volcanic terrain, including the Dallol hydrothermal fields and Erta Ale volcano.",
      fullDescription: "Experience one of the most otherworldly landscapes on Earth. The Danakil Depression is a geological wonderland of colorful hot springs, salt flats, and active volcanoes. This 4-day expedition takes you to the heart of this extreme environment.\n\nYou'll visit the Dallol hydrothermal fields with their vibrant yellow, orange, and green mineral deposits, trek to the summit of Erta Ale volcano to witness its permanent lava lake, and meet Afar people who have inhabited this harsh environment for centuries. Accommodations are basic camping with support vehicles.",
      includes: [
        "Local Afar guide",
        "4WD transport",
        "All camping equipment",
        "All meals",
        "Security escort",
        "Entrance fees"
      ],
      excludes: [
        "Travel insurance",
        "Personal expenses",
        "Tips",
        "Sleeping bag"
      ],
      itinerary: [
        { day: 1, title: "Addis to Mekele", description: "Flight to Mekele, drive to Hamedela" },
        { day: 2, title: "Dallol & Lake Assal", description: "Visit Dallol hydrothermal fields and salt lakes" },
        { day: 3, title: "Erta Ale Volcano", description: "Trek to the summit to see lava lake" },
        { day: 4, title: "Return to Mekele", description: "Drive back to Mekele, fly to Addis" }
      ],
      images: ['/images/danakil.jpg'],
      highlights: [
        "Dallol hydrothermal fields",
        "Erta Ale lava lake",
        "Salt flats and caravans",
        "Afar culture"
      ],
      meetingPoint: "Addis Ababa Bole International Airport",
      groupSize: "4-12 people",
      bestTime: "November to February (cooler months)"
    },
    'bale-mountains': {
      id: 'bale-mountains',
      title: "Bale Mountains Trek – 6 Days",
      location: "Bale Mountains",
      duration: "6 Days, 5 Nights",
      price: "On Request",
      rating: 4.9,
      reviews: 63,
      description: "Trek through dramatic peaks and spot endemic wildlife like the Ethiopian Wolf, Mountain Nyala, and Gelada Baboons.",
      fullDescription: "Discover the stunning landscapes and unique wildlife of the Bale Mountains National Park. This 6-day trek takes you through Afro-alpine meadows, bamboo forests, and rugged peaks while searching for rare endemic species.\n\nThe park is home to the critically endangered Ethiopian Wolf, the Mountain Nyala, and troops of Gelada Baboons. You'll be accompanied by experienced local guides and scout rangers who know the best spots for wildlife viewing. The trek includes camping under the stars and support from mule teams carrying equipment.",
      includes: [
        "Professional guide",
        "Armed scout ranger",
        "Mule support for equipment",
        "All camping gear",
        "All meals",
        "Park entrance fees"
      ],
      excludes: [
        "Travel insurance",
        "Personal expenses",
        "Tips",
        "Sleeping bag"
      ],
      itinerary: [
        { day: 1, title: "Addis to Dinsho", description: "Drive to park headquarters, short hike" },
        { day: 2, title: "Dinsho to Sodota", description: "Trek through bamboo forest" },
        { day: 3, title: "Sodota to Wasama", description: "Enter Afro-alpine zone, look for wolves" },
        { day: 4, title: "Wasama to Garba Guracha", description: "Trek to beautiful lake" },
        { day: 5, title: "Garba Guracha to Adaba", description: "Descend through forest" },
        { day: 6, title: "Return to Addis", description: "Drive back to Addis Ababa" }
      ],
      images: ['/images/bale.jpg'],
      highlights: [
        "Ethiopian Wolf sightings",
        "Mountain Nyala",
        "Gelada Baboons",
        "Alpine landscapes"
      ],
      meetingPoint: "Your hotel in Addis Ababa",
      groupSize: "2-8 people",
      bestTime: "October to March (dry season)"
    }
  };

  useEffect(() => {
    setLoading(true);
    // Find tour by ID
    const foundTour = toursData[id] || toursData['addis-ababa-city-tour'];
    setTour(foundTour);
    setLoading(false);
  }, [id]);

  // Create WhatsApp message based on tour
  const getWhatsAppUrl = (type = 'book') => {
    let message = '';
    
    if (type === 'book') {
      message = `Hello! I'm interested in booking the ${tour?.title} tour. Can you provide more information about pricing, availability, and how to confirm my booking?`;
    } else if (type === 'question') {
      message = `Hi, I have a question about the ${tour?.title} tour. Could you please help me with more details?`;
    } else {
      message = `Hello! I'm interested in the ${tour?.title} tour with Encourage Women Ethiopia.`;
    }
    
    return `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-[#0e7c7c] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-600">Loading tour details...</p>
        </div>
      </div>
    );
  }

  if (!tour) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">Tour Not Found</h2>
          <Link to="/tours" className="bg-[#0e7c7c] text-white px-6 py-3 rounded-full inline-block">
            View All Tours
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white">
      {/* HERO SECTION */}
      <section 
        className="relative bg-cover bg-center text-white py-40 md:py-48"
        style={{
          backgroundImage: `linear-gradient(rgba(14, 124, 124, 0.85), rgba(11, 94, 94, 0.9)), url('${tour.images?.[0] || '/images/lalibela.jpg'}')`,
          marginTop: '-80px',
          paddingTop: '120px'
        }}
      >
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-4 max-w-4xl mx-auto">{tour.title}</h1>
          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-8 text-white/90 mb-6">
            <span className="flex items-center gap-2"><FaMapMarkerAlt /> {tour.location}</span>
            <span className="flex items-center gap-2"><FaClock /> {tour.duration}</span>
            <span className="flex items-center gap-2">
              <FaStar className="text-yellow-400" /> {tour.rating} ({tour.reviews} reviews)
            </span>
          </div>
          
          {/* WhatsApp Book Button in Hero */}
          <a 
            href={getWhatsAppUrl('book')}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#20BA5C] text-white px-8 py-4 rounded-full font-semibold text-lg transition-all duration-200 shadow-lg hover:shadow-xl"
          >
            <FaWhatsapp size={24} />
            Book This Tour on WhatsApp
          </a>
        </div>
      </section>

      {/* MAIN CONTENT */}
      <section className="py-16 md:py-20">
        <div className="container mx-auto px-4 max-w-7xl">
          <div className="grid lg:grid-cols-3 gap-10">
            
            {/* LEFT COLUMN - MAIN CONTENT (2/3 width) */}
            <div className="lg:col-span-2">
              {/* Overview */}
              <div className="mb-12">
                <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">Tour Overview</h2>
                <p className="text-gray-600 leading-relaxed whitespace-pre-line">{tour.fullDescription || tour.description}</p>
              </div>
              
              {/* Highlights */}
              {tour.highlights && (
                <div className="mb-12">
                  <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">Tour Highlights</h2>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                    {tour.highlights.map((item, i) => (
                      <div key={i} className="flex items-center gap-2 text-gray-700">
                        <FaCheck className="text-[#0e7c7c] flex-shrink-0" />
                        <span>{item}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
              
              {/* Itinerary */}
              <div className="mb-12">
                <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6">Detailed Itinerary</h2>
                <div className="space-y-4">
                  {tour.itinerary.map((item, i) => (
                    <div key={i} className="bg-gray-50 p-5 rounded-xl">
                      <div className="flex items-start gap-4">
                        <div className="bg-[#0e7c7c] text-white w-10 h-10 rounded-full flex items-center justify-center font-bold flex-shrink-0">
                          {item.day || i+1}
                        </div>
                        <div className="flex-1">
                          <div className="flex flex-wrap items-center justify-between gap-2 mb-1">
                            <h3 className="font-semibold text-gray-900">{item.title}</h3>
                            {item.time && <span className="text-sm text-[#0e7c7c] font-medium">{item.time}</span>}
                          </div>
                          <p className="text-gray-600 text-sm">{item.description}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              
              {/* What's Included/Excluded */}
              <div className="grid md:grid-cols-2 gap-8 mb-12">
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                    <FaCheck className="text-green-600" /> Included
                  </h3>
                  <ul className="space-y-2">
                    {tour.includes?.map((item, i) => (
                      <li key={i} className="flex items-start gap-2 text-gray-600">
                        <FaCheck className="text-[#0e7c7c] mt-1 flex-shrink-0" />
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
                {tour.excludes && (
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-4">Excluded</h3>
                    <ul className="space-y-2">
                      {tour.excludes.map((item, i) => (
                        <li key={i} className="flex items-start gap-2 text-gray-600">
                          <span className="text-red-500 mt-1 flex-shrink-0">✕</span>
                          <span>{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
              
              {/* Practical Info */}
              <div className="bg-[#F9FAFB] p-6 rounded-xl">
                <h3 className="text-xl font-bold text-gray-900 mb-4">Practical Information</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {tour.meetingPoint && (
                    <div className="flex items-center gap-3">
                      <FaMapMarkerAlt className="text-[#0e7c7c]" />
                      <span className="text-gray-600">Meeting point: {tour.meetingPoint}</span>
                    </div>
                  )}
                  {tour.groupSize && (
                    <div className="flex items-center gap-3">
                      <FaUsers className="text-[#0e7c7c]" />
                      <span className="text-gray-600">Group size: {tour.groupSize}</span>
                    </div>
                  )}
                  {tour.bestTime && (
                    <div className="flex items-center gap-3">
                      <FaCalendar className="text-[#0e7c7c]" />
                      <span className="text-gray-600">Best time: {tour.bestTime}</span>
                    </div>
                  )}
                  <div className="flex items-center gap-3">
                    <FaFemale className="text-[#0e7c7c]" />
                    <span className="text-gray-600">Women-led tour</span>
                  </div>
                </div>
              </div>
            </div>
            
            {/* RIGHT COLUMN - BOOKING SIDEBAR (1/3 width) */}
            <div className="lg:col-span-1">
              <div className="bg-gray-50 p-8 rounded-2xl shadow-lg sticky top-24">
                <div className="text-center mb-6">
                  <span className="text-3xl font-bold text-gray-900">{tour.price}</span>
                  <p className="text-gray-500 text-sm">per person, based on group size</p>
                </div>
                
                {/* WhatsApp Booking Options */}
                <div className="space-y-3 mb-6">
                  <a 
                    href={getWhatsAppUrl('book')}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center gap-2 w-full bg-[#25D366] hover:bg-[#20BA5C] text-white font-semibold py-4 px-6 rounded-lg transition-colors duration-200 text-lg"
                  >
                    <FaWhatsapp size={24} /> Book via WhatsApp
                  </a>
                  
                  <a 
                    href={getWhatsAppUrl('question')}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-center gap-2 w-full bg-[#0e7c7c] hover:bg-[#0b5e5e] text-white font-semibold py-4 px-6 rounded-lg transition-colors duration-200"
                  >
                    <FaWhatsapp size={20} /> Ask a Question
                  </a>
                  
                  <a 
                    href={`tel:+251912093264`}
                    className="flex items-center justify-center gap-2 w-full bg-gray-200 hover:bg-gray-300 text-gray-800 font-semibold py-3 px-6 rounded-lg transition-colors duration-200"
                  >
                    <FaPhone size={18} /> Call Us
                  </a>
                </div>
                
                {/* Quick Info */}
                <div className="border-t border-gray-200 pt-6 space-y-3">
                  <div className="flex items-center gap-3 text-gray-600">
                    <FaWhatsapp className="text-[#25D366] text-xl" />
                    <span className="text-sm">Instant response via WhatsApp</span>
                  </div>
                  <div className="flex items-center gap-3 text-gray-600">
                    <FaClock className="text-[#0e7c7c]" />
                    <span className="text-sm">Typically replies within 1 hour</span>
                  </div>
                  <div className="flex items-center gap-3 text-gray-600">
                    <FaStar className="text-[#0e7c7c]" />
                    <span className="text-sm">{tour.rating} rating ({tour.reviews} reviews)</span>
                  </div>
                  <div className="flex items-center gap-3 text-gray-600">
                    <FaShieldAlt className="text-[#0e7c7c]" />
                    <span className="text-sm">Safe & secure booking</span>
                  </div>
                </div>
                
                {/* Trust Badge */}
                <div className="mt-6 p-4 bg-teal-50 rounded-xl text-center">
                  <div className="flex items-center justify-center gap-2 mb-2">
                    <FaFemale className="text-[#0e7c7c] text-xl" />
                    <FaLeaf className="text-[#0e7c7c] text-xl" />
                  </div>
                  <p className="text-sm text-gray-600">
                    <span className="font-bold text-[#0e7c7c]">🇪🇹 Women-led local operator</span><br />
                    No middlemen - best price guaranteed<br />
                    10% of profits support women's associations
                  </p>
                </div>
                
                {/* WhatsApp Direct Number */}
                <div className="mt-4 text-center">
                  <p className="text-xs text-gray-500">WhatsApp 24/7</p>
                  <a 
                    href={`https://wa.me/${whatsappNumber}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-sm font-semibold text-[#0e7c7c] hover:underline"
                  >
                    +251 912 093 264
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {/* WHY BOOK WITH US SECTION */}
      <section className="py-16 bg-[#F9FAFB]">
        <div className="container mx-auto px-4 max-w-7xl">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8 text-center">Why Book on WhatsApp?</h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
            <div className="bg-white p-6 rounded-xl text-center">
              <div className="bg-[#25D366] bg-opacity-10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <FaWhatsapp className="text-[#25D366] text-3xl" />
              </div>
              <h3 className="font-bold text-gray-900 mb-2">Instant Response</h3>
              <p className="text-sm text-gray-600">Get answers within minutes, not hours or days</p>
            </div>
            <div className="bg-white p-6 rounded-xl text-center">
              <div className="bg-[#0e7c7c] bg-opacity-10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <FaUsers className="text-[#0e7c7c] text-3xl" />
              </div>
              <h3 className="font-bold text-gray-900 mb-2">Personalized Service</h3>
              <p className="text-sm text-gray-600">Chat directly with our travel experts</p>
            </div>
            <div className="bg-white p-6 rounded-xl text-center">
              <div className="bg-[#0e7c7c] bg-opacity-10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <FaClock className="text-[#0e7c7c] text-3xl" />
              </div>
              <h3 className="font-bold text-gray-900 mb-2">24/7 Availability</h3>
              <p className="text-sm text-gray-600">Message us anytime, day or night</p>
            </div>
            <div className="bg-white p-6 rounded-xl text-center">
              <div className="bg-[#0e7c7c] bg-opacity-10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <FaShieldAlt className="text-[#0e7c7c] text-3xl" />
              </div>
              <h3 className="font-bold text-gray-900 mb-2">Secure & Easy</h3>
              <p className="text-sm text-gray-600">Simple booking process with no hidden fees</p>
            </div>
          </div>
        </div>
      </section>
      
      {/* RELATED TOURS */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4 max-w-7xl">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8 text-center">You Might Also Like</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {Object.values(toursData).filter(t => t.id !== tour.id).slice(0, 3).map((relatedTour, i) => {
              const relatedWhatsAppUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(`I'm interested in the ${relatedTour.title}. Can you send me more information?`)}`;
              
              return (
                <div key={i} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all border border-gray-100">
                  <Link to={`/tours/${relatedTour.id}`}>
                    <div className="h-48 bg-cover bg-center" style={{ backgroundImage: `url('${relatedTour.images?.[0] || '/images/lalibela.jpg'}')` }}></div>
                  </Link>
                  <div className="p-5">
                    <Link to={`/tours/${relatedTour.id}`}>
                      <h3 className="font-bold text-gray-900 mb-2 hover:text-[#0b5e5e] transition-colors">{relatedTour.title}</h3>
                    </Link>
                    <div className="flex items-center gap-3 text-sm text-gray-500 mb-3">
                      <span className="flex items-center gap-1"><FaMapMarkerAlt /> {relatedTour.location.split(',')[0]}</span>
                      <span className="flex items-center gap-1"><FaClock /> {relatedTour.duration}</span>
                    </div>
                    <div className="flex items-center justify-between">
                      <span className="text-[#0e7c7c] font-semibold">Price: {relatedTour.price}</span>
                      <a 
                        href={relatedWhatsAppUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="bg-[#25D366] hover:bg-[#20BA5C] text-white p-2 rounded-full transition-colors"
                        title="Inquire on WhatsApp"
                      >
                        <FaWhatsapp size={18} />
                      </a>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
      
      {/* CTA SECTION */}
      <section className="py-16 bg-gradient-to-br from-[#0b5e5e] to-[#0e7c7c] text-white">
        <div className="container mx-auto px-4 text-center max-w-4xl">
          <h2 className="text-2xl md:text-3xl font-bold mb-4">Ready to Book This Tour?</h2>
          <p className="text-lg mb-8 text-white/90">
            Contact us on WhatsApp for immediate assistance with pricing, availability, and customization.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href={getWhatsAppUrl('book')}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#20BA5C] text-white px-8 py-4 rounded-full font-bold text-lg transition-all duration-200 shadow-lg"
            >
              <FaWhatsapp size={24} /> Book on WhatsApp Now
            </a>
            <Link 
              to="/contact"
              className="inline-flex items-center justify-center gap-2 border-2 border-white text-white hover:bg-white hover:text-[#0b5e5e] px-8 py-4 rounded-full font-bold text-lg transition-colors duration-200"
            >
              <FaEnvelope /> Send Email Inquiry
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TourDetail;